import { useFormState } from "react-final-form";

// The fields that trigger rate re-resolution, minus `rate`, which
// `clearRateField` writes itself. See D7 in complete-rate-amount-match.
const rateInputs = ["date", "project", "useCustomRate", "employee"];

/**
 * Whether the user has modified any input the rate depends on. Until they do,
 * the loaded charge's rate and rate amount stand.
 */
export function useRateInputsModified(): boolean {
  const { modified } = useFormState({ subscription: { modified: true } });

  return rateInputs.some((field) => modified?.[field]);
}
